import React, { Component } from 'react'
import Link from '../../utils/link'
import Sold from '../../assets/images/sold.svg'
import { Bed, Bath, Car, Land, Build } from '../icons'
import Fade from 'react-reveal/Fade'
import moment from 'moment-timezone'

class PropertyCard extends Component {

  render() {
    const { slug, title, databaseId, propertyAddress, propertyImages, propertyInspections, propertyData, propertyLand, propertyListing, postType, propertyType } = this.props
    const sold = propertyListing?.marketingStatus === 'Sold'

    let pathName = `/${postType}/${slug}/`
    let heading = `${propertyAddress.streetAddress}<br />${propertyAddress.suburb} ${propertyAddress.postcode}`
    if (propertyAddress.hideAddress) {
      heading = propertyAddress.suburb
      pathName = `/${postType}/${propertyAddress.suburb.toLowerCase().replace(/ /gi, '-')}-${databaseId}/`
    }

    // get first inspection that is in the future
    let inspection = propertyInspections?.find(inspection => moment(inspection.startDate).isAfter())

    return (
      <div className={`property ${sold ? 'property--sold' : ''}`}>
        <div className='property__image'>
          <img src={propertyImages?.length > 0 && propertyImages[0].large} alt={title} />
          { sold && <img className='sold' src={Sold} alt='Sold' /> }
          { propertyListing?.auctionDate && moment(propertyListing.auctionDate).isAfter() && 
            <div className='property__auction'>
              Auction {moment(propertyListing.auctionDate).tz("Australia/Brisbane").format("ddd D MMM h:mmA")}
            </div> 
          }
          { inspection && !propertyListing?.auctionDate &&
            <div className='property__auction'>
              Inspection {moment(inspection.startDate).tz("Australia/Brisbane").format("ddd D MMM h:mmA")}
            </div>
          }
          <div className='property__rollover property__rollover--desktop'>
            <div className='property__title'>
              <h4 dangerouslySetInnerHTML={{ __html: heading }} />
            </div>
            <div className='property__meta'>
              <span>{propertyListing?.displayPrice}</span>
              { propertyData.type !== 'Commercial' &&
                <ul className='property__specs property__specs--desktop'>
                  { propertyData?.bedrooms > 0 && <li><Bed color={`#FFFFFF`} /> {propertyData?.bedrooms}</li> }
                  { propertyData?.bathrooms > 0 && <li><Bath color={`#FFFFFF`} /> {propertyData?.bathrooms}</li> }
                  { propertyData?.totalParking > 0 && <li><Car color={`#FFFFFF`} /> {propertyData?.totalParking}</li> }
                </ul>
              }
              { propertyData.type === 'Commercial' &&
                <ul className='property__specs property__specs--desktop property__specs--commercial'>
                  { propertyData?.totalParking > 0 && <li><Car color={`#FFFFFF`} /> {propertyData?.totalParking}</li> }
                  { propertyLand?.buildingArea_value && <li className='area'><Build color={`#FFFFFF`} /> {propertyLand.buildingArea_value}{propertyLand.buildingArea_unit === 'sqm' ? '㎡' : propertyLand.buildingArea_unit+'s'}</li> }
                  { propertyLand?.landArea_value && <li className='area'><Land color={`#FFFFFF`} /> {propertyLand.landArea_value}{propertyLand.landArea_unit === 'sqm' ? '㎡' : propertyLand.landArea_unit+'s'}</li> }
                </ul>
              }
            </div>
          </div>
        </div>
        <div>
        <div className='property__rollover property__rollover--mobile'>
          <div className='property__title'>
            <h4 dangerouslySetInnerHTML={{ __html: heading }} />
          </div>
          <div className='property__meta'>
            <span>{propertyListing?.displayPrice}</span>
            { propertyData.type !== 'Commercial' &&
              <ul className='property__specs property__specs--desktop'>
                { propertyData?.bedrooms > 0 && <li><Bed color={`#FFFFFF`} /> {propertyData?.bedrooms}</li> }
                { propertyData?.bathrooms > 0 && <li><Bath color={`#FFFFFF`} /> {propertyData?.bathrooms}</li> }
                { propertyData?.totalParking > 0 && <li><Car color={`#FFFFFF`} /> {propertyData?.totalParking}</li> }
              </ul>
            }
            { propertyData.type === 'Commercial' &&
              <ul className='property__specs property__specs--desktop property__specs--commercial'>
                { propertyData?.totalParking > 0 && <li><Car color={`#FFFFFF`} /> {propertyData?.totalParking}</li> }
                { propertyLand?.buildingArea_value && <li className='area'><Build color={`#FFFFFF`} /> {propertyLand.buildingArea_value}{propertyLand.buildingArea_unit === 'sqm' ? '㎡' : propertyLand.buildingArea_unit+'s'}</li> }
                { propertyLand?.landArea_value && <li className='area'><Land color={`#FFFFFF`} /> {propertyLand.landArea_value}{propertyLand.landArea_unit === 'sqm' ? '㎡' : propertyLand.landArea_unit+'s'}</li> }
              </ul>
            }
          </div>
        </div>
        { propertyData.type !== 'Commercial' &&
          <ul className='property__specs property__specs--mobile property__specs--commercial'>
            { propertyData?.bedrooms > 0 && <li><Bed color={`#FFFFFF`} /> {propertyData?.bedrooms}</li> }
            { propertyData?.bathrooms > 0 && <li><Bath color={`#FFFFFF`} /> {propertyData?.bathrooms}</li> }
            { propertyData?.totalParking > 0 && <li><Car color={`#FFFFFF`} /> {propertyData?.totalParking}</li> }
          </ul>
        }
        { propertyData.type === 'Commercial' &&
          <ul className='property__specs property__specs--mobile property__specs--commercial'>
            { propertyData?.totalParking > 0 && <li><Car color={`#FFFFFF`} /> {propertyData?.totalParking}</li> }
            { propertyLand?.buildingArea_value && <li className='area'><Build color={`#FFFFFF`} /> {propertyLand.buildingArea_value}{propertyLand.buildingArea_unit === 'sqm' ? '㎡' : propertyLand.buildingArea_unit+'s'}</li> }
            { propertyLand?.landArea_value && <li className='area'><Land color={`#FFFFFF`} /> {propertyLand.landArea_value}{propertyLand.landArea_unit === 'sqm' ? '㎡' : propertyLand.landArea_unit+'s'}</li> }
          </ul>
        }
        </div>

        <Link className='property__link' to={pathName} />
      </div>
    )
  }
}

export default PropertyCard
